<div class="navigation-dropdown">
  <ion-select
    [(ngModel)]="selectedNav"
    (ionChange)="onNavigationChange($event)"
    [placeholder]="'ADMIN.SELECT_SECTION' | translate"
    interface="popover">
    <ion-select-option value="portal">{{ 'ADMIN.PORTAL_HOME' | translate }}</ion-select-option>
    <ion-select-option value="accounts">{{ 'ADMIN.ACCOUNTS' | translate }}</ion-select-option>
    <ion-select-option value="network-devices">{{ 'ADMIN.NETWORK_DEVICES' | translate }}</ion-select-option>
    <ion-select-option value="users">{{ 'ADMIN.USERS' | translate }}</ion-select-option>
    <ion-select-option value="toggles">{{ 'ADMIN.TOGGLES' | translate }}</ion-select-option>
    <ion-select-option value="kilns">{{ 'ADMIN.KILNS' | translate }}</ion-select-option>
    <ion-select-option value="storage">{{ 'ADMIN.STORAGE' | translate }}</ion-select-option>
    <ion-select-option value="distributors">{{ 'ADMIN.DISTRIBUTORS' | translate }}</ion-select-option>
    <ion-select-option value="terms">{{ 'ADMIN.TERMS_AND_CONDITIONS' | translate }}</ion-select-option>
    <ion-select-option *ngIf="canAccessContactsSections()" value="phones-emails">{{ 'ADMIN.PHONES_EMAILS_TITLE' | translate }}</ion-select-option>
    <ion-select-option *ngIf="canAccessContactsSections()" value="kiln-names">{{ 'ADMIN.KILN_NAMES_TITLE' | translate }}</ion-select-option>
    <ion-select-option *ngIf="userService.hasElevatedPermissions()" value="login-failures">{{ 'ADMIN.LOGIN_FAILURES_TITLE' | translate }}</ion-select-option>
    <ion-select-option *ngIf="userService.hasElevatedPermissions()" value="kiln-claim-failures">{{ 'ADMIN.KILN_CLAIM_FAILURES_TITLE' | translate }}</ion-select-option>
  </ion-select>
</div>
